const adjectives = [
  "Silent",
  "Golden",
  "Electric",
  "Hidden",
  "Cosmic",
  "Crimson",
  "Lucky",
  "Brave",
  "Shadow",
  "Crystal",
  "Iron",
  "Rapid",
  "Neon",
  "Curious",
  "Calm",
  "Swift",
  "Bright",
  "Silver",
  "Ancient",
  "Wild",
  "Clever",
  "Quiet",
  "Bold",
  "Fierce",
  "Noble",
  "Radiant",
  "Steady",
  "Stormy",
  "Frozen",
  "Burning",
  "Flying",
  "Wandering",
  "Lone",
  "Wise",
  "Gentle",
  "Mighty",
  "Daring",
  "Shining",
  "Restless",
  "Fearless",
  "Glowing",
  "Sharp",
  "Deep",
  "Amber",
  "Emerald",
  "Azure",
  "Scarlet",
  "Obsidian",
  "Ivory",
  "Thunder"
];

const nouns = [
  "Falcon",
  "Voyager",
  "Tiger",
  "Wolf",
  "Phoenix",
  "Comet",
  "Scholar",
  "Navigator",
  "Lion",
  "Hawk",
  "Panther",
  "Nomad",
  "Builder",
  "Oracle",
  "Pilot",
  "Ranger",
  "Guardian",
  "Seeker",
  "Hunter",
  "Keeper",
  "Sailor",
  "Climber",
  "Drifter",
  "Thinker",
  "Runner",
  "Watcher",
  "Speaker",
  "Writer",
  "Dreamer",
  "Rider",
  "Captain",
  "Sentinel",
  "Explorer",
  "Strategist",
  "Architect",
  "Engineer",
  "Inventor",
  "Messenger",
  "Diplomat",
  "Pioneer",
  "Pathfinder",
  "Harbinger",
  "Beacon",
  "Lantern",
  "Compass",
  "Anchor",
  "Summit",
  "Horizon",
  "Atlas",
  "Voyage"
];

export function generateUsername() {
  const adj = adjectives[Math.floor(Math.random() * adjectives.length)];
  const noun = nouns[Math.floor(Math.random() * nouns.length)];
//   const number = Math.floor(Math.random() * 900 + 100);

  return `${adj}${noun}`;
}